export default "__VITE_ASSET__BYJE4wtR__"